<template>
  <div>
    <m-layout-grid class="app-layout-grid--content">
      <app-layout-grid-inner-custom class="app-inmuebles-detail__pagination">
        <m-layout-grid-cell
          :span-phone="4"
          bolder
          :span-tablet="8"
          :span-desktop="12"
        >
          <m-button @click="onButtonVolverAlListadoClicked">
            <m-icon slot="icon" icon="arrow_back" />
            Volver al listado
          </m-button>
        </m-layout-grid-cell>
      </app-layout-grid-inner-custom>
      <app-layout-grid-inner-custom class="app-inmuebles-detail__data">
        <m-layout-grid-cell :span-phone="4" :span-tablet="8" :span-desktop="12">
          <m-layout-grid class="app-layout-grid--detail-container">
            <m-layout-grid-inner>
              <m-layout-grid-cell
                :span-phone="4"
                :span-tablet="8"
                :span-desktop="12"
                class="app-layout-grid-cell--detail__tipoBien"
              >
                {{ itemData.tipoBien }}
              </m-layout-grid-cell>
              <m-layout-grid-cell
                :span-phone="4"
                :span-tablet="4"
                :span-desktop="7"
              >
                <m-layout-grid class="app-layout-grid--detail-container__data">
                  <m-layout-grid-inner>
                    <m-layout-grid-cell
                      :span-phone="4"
                      :span-tablet="8"
                      :span-desktop="12"
                      class="app-layout-grid-cell--detail__promocion"
                    >
                      Promoción {{ itemData.nombrePromocion }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="4"
                      :span-tablet="8"
                      :span-desktop="12"
                      class="app-layout-grid-cell--detail__municipio"
                    >
                      {{ capitalize(itemData.provincia) }} /
                      {{ capitalize(itemData.municipio) }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-titulo"
                    >
                      Superficie / m² útiles
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-titulo"
                    >
                      Referencia
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-valor"
                    >
                      {{ itemData.superficie }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-valor"
                    >
                      {{ itemData.referencia }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-titulo"
                    >
                      Edificabilidad / m² construidos
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-titulo"
                    >
                      <span v-if="itemData.direccionPostal"
                        >Dirección postal</span
                      >
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-valor"
                    >
                      {{ itemData.edificabilidad }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="2"
                      :span-tablet="4"
                      :span-desktop="6"
                      class="app-layout-grid-cell--campo-valor"
                    >
                      {{ itemData.direccionPostal }}
                    </m-layout-grid-cell>
                    <m-layout-grid-cell
                      :span-phone="4"
                      :span-tablet="8"
                      :span-desktop="12"
                      class="app-layout-grid-cell--observaciones"
                    >
                      <a
                        v-if="itemData.fichaUrl"
                        target="_blank"
                        title="Ficha promocional"
                        class="app-link--document"
                        :href="itemData.fichaUrl"
                        @click="onFichaClicked"
                        >Ficha de la promoción</a
                      >
                      <div
                        class="app-text-observaciones"
                        v-html="
                          formatObservacionesToHTML(itemData.observaciones)
                        "
                      ></div>
                      <div
                        v-if="
                          itemData.videos &&
                            itemData.videos[videoLanguageSelected]
                        "
                        class="video-container"
                      >
                        <div class="video-container__video">
                          <transition name="transition-fade">
                            <youtube
                              v-if="itemData.videos[videoLanguageSelected]"
                              :video-id="videoIdSelected"
                              ref="youtube"
                              :fitParent="true"
                              @playing="onVideoPlay"
                            ></youtube>
                          </transition>
                        </div>
                        <div
                          class="video-container__language"
                          v-if="Object.entries(this.itemData.videos).length > 1"
                        >
                          <m-button
                            v-for="(videoId, language) in this.itemData.videos"
                            :key="language"
                            @click="videoLanguageOnChanged(language)"
                            v-bind:class="{
                              'mdc-button--selected':
                                language === videoLanguageSelected
                            }"
                          >
                            <img
                              v-if="language === 'es'"
                              src="../assets/flag-es.png"
                              alt="Ver video con idioma español"
                              title="Ver video con idioma español"
                            />
                            <img
                              v-if="language === 'en'"
                              src="../assets/flag-en.png"
                              alt="Play video with English language"
                              title="Play video with English language"
                            />
                            <img
                              v-if="language === 'ge'"
                              src="../assets/flag-ge.png"
                              alt="Video in deutscher Sprache abspielen"
                              title="Video in deutscher Sprache abspielen"
                            />
                            <img
                              v-if="language === 'po'"
                              src="../assets/flag-po.png"
                              alt="Assistir vídeo em português"
                              title="Assistir vídeo em português"
                            />
                            <img
                              v-if="language === 'fr'"
                              src="../assets/flag-fr.png"
                              alt="Lire la vidéo en français"
                              title="Lire la vidéo en français"
                            />
                          </m-button>
                        </div>
                      </div>
                      <div class="app-layout-grid-cell--detail__mapa">
                        <transition name="transition-fade">
                          <app-mapa-inmuebles
                            v-if="itemData.isEnMapa"
                            ap-map-id="mapa-detalle"
                            :ap-poligono="itemData.poligono"
                            :ap-poligono2="itemData.poligono2"
                            ap-style="width: 100%; height:400px; margin-bottom: 3em"
                          >
                          </app-mapa-inmuebles>
                        </transition>
                      </div>
                    </m-layout-grid-cell>
                  </m-layout-grid-inner>
                </m-layout-grid>
              </m-layout-grid-cell>
              <m-layout-grid-cell
                :span-phone="4"
                :span-tablet="4"
                :span-desktop="5"
              >
                <m-card
                  outlined
                  class="app-layout-grid--detail-container__contacto"
                >
                  <div>
                    <m-layout-grid>
                      <m-layout-grid-inner>
                        <m-layout-grid-cell
                          :span-phone="4"
                          :span-tablet="8"
                          :span-desktop="5"
                          class="app-layout-grid-cell--detail__form-contacto__estado"
                        >
                          <div class="detail__form-contacto__estado">
                            <m-icon :icon="iconForOferta(itemData.oferta)" />
                            <span>{{ formatOferta(itemData.oferta) }}</span>
                          </div>
                          <div
                            class="detail__form-contacto__precio"
                            v-if="itemData.precio && itemData.oferta === 'S'"
                          >
                            {{ formatCurrency(itemData.precio) }}
                          </div>
                        </m-layout-grid-cell>
                        <m-layout-grid-cell
                          :span-phone="4"
                          :span-tablet="8"
                          :span-desktop="7"
                          class="app-layout-grid-cell--detail__form-contacto__estoyinteresado"
                        >
                          <m-button
                            raised
                            v-if="uiContacto.isButtonInteresadoShown"
                            @click="onButtonInteresadoClicked"
                          >
                            Tengo interés
                          </m-button>
                        </m-layout-grid-cell>
                        <m-layout-grid-cell
                          :span-phone="4"
                          :span-tablet="8"
                          :span-desktop="12"
                          style="border-top: solid 1px #e0e1e2;"
                        >
                        </m-layout-grid-cell>
                        <template v-if="uiContacto.isFormularioShown">
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            style="margin-bottom: 2em; font-size: 13px; text-align: justify; color: #455a64"
                          >
                            Puede pedir más información llamando por teléfono a
                            la dirección provincial (
                            <a
                              target="_blank"
                              title="Este enlace abre una nueva ventana"
                              class="app-link--open-in-new"
                              href="http://www.juntadeandalucia.es/avra/opencms/servicios/Directorio/index.html"
                              @click="onEnlaceTelefonosClick()"
                              >información de sedes aquí</a
                            >
                            ) o enviando el siguiente formulario:
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                          >
                            <m-text-field
                              v-model="uiContacto.formulario.referencia"
                              id="contacto-referencia"
                              outlined
                              disabled
                            >
                              <m-floating-label for="contacto-referencia"
                                >Referencia</m-floating-label
                              >
                            </m-text-field>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                          >
                            <m-text-field
                              v-model="uiContacto.formulario.consulta"
                              id="contacto-texto"
                              textarea
                              maxlength="140"
                              required
                              :valid="!$v.uiContacto.formulario.consulta.$error"
                            >
                              <m-floating-label for="contacto-texto"
                                >Consulta</m-floating-label
                              >
                            </m-text-field>
                            <m-text-field-helper-line>
                              <m-text-field-helper-text>
                                {{
                                  errorMessage(
                                    $v.uiContacto.formulario.consulta
                                  )
                                }}
                              </m-text-field-helper-text>
                              <m-text-field-character-counter></m-text-field-character-counter>
                            </m-text-field-helper-line>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                          >
                            <m-text-field
                              v-model="uiContacto.formulario.email"
                              v-on:keyup.native.enter="onButtonContactarClicked"
                              id="contacto-email"
                              outlined
                              required
                              type="email"
                              :valid="!$v.uiContacto.formulario.email.$error"
                            >
                              <m-floating-label for="contacto-email"
                                >Email</m-floating-label
                              >
                            </m-text-field>
                            <m-text-field-helper-line>
                              <m-text-field-helper-text>
                                {{
                                  errorMessage($v.uiContacto.formulario.email)
                                }}
                              </m-text-field-helper-text>
                            </m-text-field-helper-line>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="4"
                            :span-desktop="6"
                          >
                            <m-text-field
                              v-model="uiContacto.formulario.telefono"
                              v-on:keyup.native.enter="onButtonContactarClicked"
                              id="contacto-telefono"
                              minlength="9"
                              outlined
                              :valid="!$v.uiContacto.formulario.telefono.$error"
                            >
                              <m-floating-label for="contacto-telefono"
                                >Teléfono</m-floating-label
                              >
                            </m-text-field>
                            <m-text-field-helper-line>
                              <m-text-field-helper-text>
                                {{
                                  errorMessage(
                                    $v.uiContacto.formulario.telefono
                                  )
                                }}
                              </m-text-field-helper-text>
                            </m-text-field-helper-line>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="4"
                            :span-desktop="6"
                          >
                            <m-text-field
                              v-model="uiContacto.formulario.nombre"
                              v-on:keyup.native.enter="onButtonContactarClicked"
                              id="contacto-nombre"
                              outlined
                            >
                              <m-floating-label for="contacto-nombre"
                                >Nombre</m-floating-label
                              >
                            </m-text-field>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="4"
                            :span-desktop="6"
                          >
                            <m-select
                              v-model="uiContacto.formulario.sexo"
                              id="contacto-sexo"
                              outlined
                            >
                              <option value="Mujer">
                                Mujer
                              </option>
                              <option value="Hombre">
                                Hombre
                              </option>
                              <m-floating-label
                                slot="label"
                                for="contacto-sexo"
                              >
                                Sexo
                              </m-floating-label>
                            </m-select>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="4"
                            :span-desktop="6"
                          >
                            <m-select
                              v-model="uiContacto.formulario.particular"
                              id="contacto-particular"
                              outlined
                            >
                              <option value="Particular">
                                Particular
                              </option>
                              <option value="Empresa">
                                Empresa
                              </option>
                              <m-floating-label
                                slot="label"
                                for="contacto-particular"
                              >
                                Particular o empresa
                              </m-floating-label>
                            </m-select>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                          >
                            <m-button raised @click="onButtonContactarClicked">
                              Contactar
                            </m-button>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            style="border-top: solid 1px #e0e1e2;"
                          >
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            style="font-size: 13px; text-align: justify; color: #455a64"
                          >
                            Le informamos que los datos que usted nos
                            proporcione, cumplimentando el presente formulario,
                            serán tratados por el responsable, Agencia de
                            Vivienda y Rehabilitación de Andalucía, calle Pablo
                            Picasso, 6 41018 Sevilla, con la finalidad de
                            atenderle y suministrarle la información comercial
                            por usted interesada. Le informamos igualmente que
                            podrá ejercer sus derechos de acceso, rectificación,
                            oposición, supresión (“derecho al olvido”),
                            limitación del tratamiento y portabilidad
                            cumplimentando
                            <a
                              target="_blank"
                              title="Este enlace abre una nueva ventana"
                              class="app-link--open-in-new"
                              href="http://www.juntadeandalucia.es/avra/opencms/servicios/contacto.html"
                              >en este enlace</a
                            >
                            el formulario de contacto de nuestra web. Igualmente
                            podrá obtener mayor información sobre protección de
                            datos clicando en
                            <a
                              target="_blank"
                              title="Este enlace abre una nueva ventana"
                              class="app-link--open-in-new"
                              href="http://www.juntadeandalucia.es/avra/opencms/general/politica-privacidad.html"
                              >este enlace de nuestra polícita de privacidad</a
                            >
                          </m-layout-grid-cell>
                        </template>
                        <template v-if="uiContacto.isResultadoEnvioShown">
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            class="app-layout-grid-cell--detail__form-contacto__respuesta__text"
                          >
                            <div>
                              <div
                                v-html="uiContacto.saveConsultaResultMsg"
                              ></div>
                            </div>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            v-if="uiContacto.isButtonVolverListadoShown"
                          >
                            <m-button @click="onButtonVolverAlListadoClicked">
                              Quiero mirar más inmuebles
                            </m-button>
                          </m-layout-grid-cell>
                          <m-layout-grid-cell
                            :span-phone="4"
                            :span-tablet="8"
                            :span-desktop="12"
                            v-if="uiContacto.isButtonVolverFormularioShown"
                          >
                            <m-button
                              @click="onButtonVolverAlFormularioClicked"
                            >
                              Volver al formulario
                            </m-button>
                          </m-layout-grid-cell>
                        </template>
                      </m-layout-grid-inner>
                    </m-layout-grid>
                  </div>
                </m-card>
              </m-layout-grid-cell>
            </m-layout-grid-inner>
          </m-layout-grid>
        </m-layout-grid-cell>
      </app-layout-grid-inner-custom>
    </m-layout-grid>
  </div>
</template>

<script>
import { required, email, numeric, minLength } from "vuelidate/lib/validators";
import AppMixinAnalytics from "@/components/AppMixinAnalytics.js";
import Vue from "vue";
import VueYoutube from "vue-youtube";

Vue.use(VueYoutube);

export default {
  name: "inmuebles-detail",
  props: {
    cachedItemData: {
      type: Object,
      default: null
    },
    // Para comprobar si viene del listado o se ha llamado desde una url a pelo
    // (pq esto? por al volver en vez de dar history.back volveré a inmuebles a pelo )
    prevRoute: { type: Object },
    prevListData: { type: Object },
    prevMapData: { type: Object }
  },
  mixins: [AppMixinAnalytics],
  data() {
    return {
      itemData: {},
      videoLanguageSelected: "es",
      uiContacto: {
        isButtonInteresadoShown: true,
        isFormularioShown: false,
        isResultadoEnvioShown: false,
        isButtonVolverListadoShown: true,
        isButtonVolverFormularioShown: false,
        formulario: {
          referencia: "",
          asunto: "",
          consulta:
            "Hola, tengo interés en este inmueble y os agradecería que os pusieseis en contacto conmigo. Un saludo ",
          email: "",
          telefono: "",
          nombre: "",
          sexo: "",
          particular: ""
        },
        saveConsultaResultMsg: ""
      }
    };
  },
  computed: {
    videoIdSelected() {
      return this.itemData.videos &&
        this.itemData.videos[this.videoLanguageSelected]
        ? this.itemData.videos[this.videoLanguageSelected]
        : null;
    }
  },
  validations: {
    uiContacto: {
      formulario: {
        email: { required, email },
        consulta: { required },
        telefono: { numeric, minLength: minLength(9) }
      }
    }
  },
  mounted() {
    if (this.cachedItemData) {
      this.itemData = this.cachedItemData;
      this.sendAnalyticsEventWithInmuebleItem(
        "inmueble_consultado",
        this.itemData
      );
    } else {
      this.itemData = {};
      this.updateDataListItemWithExternalData();
    }
  },
  methods: {
    videoLanguageOnChanged(newVideoLanguage) {
      this.videoLanguageSelected = newVideoLanguage;
    },
    updateDataListItemWithExternalData() {
      var self = this;
      var ref = this.$route.params.id;

      // var codPromo = ref.substr(0, ref.indexOf("-"));
      // var codPrinex = ref.substr(ref.indexOf("-") + 1, ref.length);

      var options = {
        paginationCurrentPage: 1,
        paginationResultsPerPage: 2,
        fullTextSearch: null,
        sortFieldName: null,
        sortOrder: null,
        totalResultsNumber: null,
        // ya tenemos filtro por referencia
        // filterTerms: { COD_PROMO: codPromo, COD_PRINEX: codPrinex },
        filterTerms: { referencia: ref },
        fixedFilterTerms: {}
      };

      // Dejamos la pantallita bien puestecita para que se vea bien los resultados
      this.isFilterFullOpened = false;
      this.scrollToTop();

      this.$mdApp.dataAccess
        .readList("inmuebles", options)
        .then(function(response) {
          var rows = [];

          if (Array.isArray(response.data)) {
            rows = response.data.map(function(item) {
              self.transformInmuebleListItemFromDataItem(item);
              return self.transformInmuebleListItemFromDataItem(item);
            });
          }

          // Si existe va a aser un array de 1 (esto es un chapu debería devolver sólo 1, pero bueno...)
          if (rows[0]) {
            self.itemData = rows[0];
          }

          self.sendAnalyticsEventWithInmuebleItem(
            "inmueble_consultado",
            self.itemData
          );
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    transformInmuebleItemVideosFieldFromDataItem(item) {
      let videos = {};

      if (item.video_url) {
        let videoId = item.video_url.replace("https://youtu.be/", "");
        videoId = videoId.replace("https://www.youtube.com/watch?v=", "");
        videos["es"] = videoId;
      }

      return videos;
    },
    transformInmuebleListItemFromDataItem(item) {
      let result = {
        tipoBien: item.tipo_inmueble,
        referencia: item.referencia_inmueble,
        nombrePromocion: item.nombre,
        provincia: item.provincia,
        superficie: item.mutiles ? item.mutiles + " m²" : "",
        // estado: item.estado.toLowerCase(),
        //mientras se implementa el estado
        estado: "consultar",
        edificabilidad: item.mconstruidos ? item.mconstruidos + " m²" : "",
        codigoPromocion: item.cod_promo.toString(),
        codigoUnidad: item.cod_prinex,
        municipio: item.municipio,
        oferta: item.oferta,
        observaciones: item.observaciones ? item.observaciones : "",
        direccionPostal: item.direccion_postal ? item.direccion_postal : "",
        isEnMapa: item.enmapa && item.enmapa === "S" ? true : false,
        precio:
          item.precio && item.oferta && item.oferta === "S" ? item.precio : "",
        tipoOferta: item.tipo_oferta ? item.tipo_oferta : "",
        poligono: item.poligono ? item.poligono : "",
        poligono2: item.poligono2 ? item.poligono2 : "",
        centroide: item.centroide ? item.centroide : "",
        fichaUrl: item.ficha_url ? item.ficha_url : "",
        videos: this.transformInmuebleItemVideosFieldFromDataItem(item)
      };

      return result;
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
    iconForOferta(oferta) {
      switch (oferta) {
        case "S":
          return "thumb_up";
        default:
          return "contact_support";
      }
    },
    formatCurrency(money) {
      var moneyFormatted = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR"
      }).format(money);

      if (money >= 1000 && money < 10000) {
        // No pone millar si solo hay unidades de millar, y se quiere que salga punto
        moneyFormatted = moneyFormatted[0] + "." + moneyFormatted.slice(1);
      }

      moneyFormatted = moneyFormatted.replace(",00", "").replace("..", ".");

      return moneyFormatted;
    },
    formatOferta(oferta) {
      return oferta && oferta === "S" ? "en venta" : "consultar";
    },
    getId4UrlWebGestionActivos: function(e) {
      return e.codigoUnidad
        .replaceAll(" -.", "")
        .replaceAll(" --", "")
        .replaceAll(" ", "")
        .replaceAll("º", "o")
        .replace("OF-", "");
    },
    formatObservacionesToHTML(text) {
      // sustituimos de manera global los \n a <br> para que se vea bien el código
      var textFormatted = this.capitalize(text).replace(/\n/g, "<br>");

      // Los locales en web gestion activos es local comercial
      var tipoBien4Oferta = this.itemData.tipoBien;

      if (tipoBien4Oferta === "LOCALES") {
        tipoBien4Oferta = "LOCAL COMERCIAL";
      }

      if (
        this.itemData.oferta &&
        this.itemData.oferta === "S" &&
        this.itemData.tipoOferta &&
        this.itemData.tipoBien
      ) {
        // Añadimos como observación el enlace a la oferta continuada
        textFormatted =
          'Este inmueble se encuentra incluido en oferta. <a target="_blank" title="Este enlace abre una nueva ventana" class="app-link--open-in-new" href="https://www.juntadeandalucia.es/avra/gestion-activos/inmueble/' +
          this.getId4UrlWebGestionActivos(this.itemData) +
          '">Mostrar la información detallada</a><br><br>' +
          text;
      }

      if (!textFormatted && !this.itemData.fichaUrl) {
        textFormatted = "No hay observaciones para este inmueble";
      }

      return textFormatted;
    },
    isFormularioInteresadoValid() {
      this.$v.uiContacto.formulario.$touch();
      return !this.$v.uiContacto.formulario.$invalid;
    },
    onButtonInteresadoClicked() {
      this.uiContacto.isButtonInteresadoShown = false;
      this.uiContacto.isFormularioShown = true;
      this.uiContacto.formulario.referencia = this.itemData.referencia;
      this.uiContacto.formulario.provincia = this.itemData.provincia;
      this.uiContacto.formulario.nombrePromocion = this.itemData.nombrePromocion;

      this.sendAnalyticsEventWithInmuebleItem(
        "click_en_estoy_interesado",
        this.itemData
      );

      throw "Error de prueba";
    },
    onFichaClicked() {
      this.sendAnalyticsEventWithInmuebleItem(
        "click_en_ver_ficha",
        this.itemData
      );
    },
    onVideoPlay() {
      this.sendAnalyticsEventWithInmuebleItem(
        "click_en_play_video",
        this.itemData
      );
    },
    onEnlaceTelefonosClick() {
      this.sendAnalyticsEventWithInmuebleItem(
        "click_en_enlace_telefonos_sedes",
        this.itemData
      );
    },
    onButtonContactarClicked() {
      var self = this;

      if (this.isFormularioInteresadoValid()) {
        this.uiContacto.isFormularioShown = false;

        // Creamos los parametros que espera al servicio rest
        this.uiContacto.formulario.asunto =
          "Interesado en inmueble " + this.uiContacto.formulario.referencia;

        // Antes de lanzar la consulta activamos el spinner de espera
        self.uiContacto.saveConsultaResultMsg =
          '<p class="blinking">Enviando su consulta...</p>';
        this.uiContacto.isResultadoEnvioShown = true;

        this.$mdApp.dataAccess
          .createItem("consultas", this.uiContacto.formulario)
          .then(function(response) {
            var requestSuccess = false;

            if (
              response.data &&
              Array.isArray(response.data) &&
              response.data[0]
            ) {
              self.uiContacto.saveConsultaResultMsg = response.data[0].text;
              requestSuccess = response.data[0].success;
            } else {
              self.uiContacto.saveConsultaResultMsg = response.data.text;
              requestSuccess = response.data.success;
            }
            self.uiContacto.isButtonVolverListadoShown = requestSuccess;
            self.uiContacto.isButtonVolverFormularioShown = !self.uiContacto
              .isButtonVolverListadoShown;

            if (requestSuccess) {
              self.sendAnalyticsEventWithInmuebleItem(
                "consulta_enviada_con_exito",
                self.itemData
              );
            }
          });

        this.sendAnalyticsEventWithInmuebleItem(
          "click_en_contactar",
          this.itemData
        );
      }
    },
    onButtonVolverAlListadoClicked() {
      if (this.prevRoute) {
        // Viene de una ruta así que hago un history.back y listo
        // y no se vuelve a cargar ná de ná
        this.prevRoute.params.prevListData = this.prevListData;
        this.prevRoute.params.prevMapData = this.prevMapData;
        this.$router.push(this.prevRoute);
      } else {
        this.$router.push({ name: "inmuebles-list" });
      }
    },
    onButtonVolverAlFormularioClicked() {
      this.uiContacto.isButtonInteresadoShown = false;
      this.uiContacto.isButtonVolverFormularioShown = false;
      this.uiContacto.isFormularioShown = true;
    },
    filterTerms4inmueble() {
      return {
        TIPO_OFERTA: this.itemData.tipoOferta,
        PROVINCIA: this.itemData.provincia,
        TIPO_BIEN: this.itemData.tipoBien,
        CODPRINEXPROMO: this.itemData.codigoPromocion,
        CODPRINEXUNIDAD: this.itemData.codigoUnidad
      };
    },
    // errorMessage(requiredValid, emailValid) {
    //   var errorMsg = "";

    //   if (!requiredValid) {
    //     errorMsg = errorMsg + "Es obligatorio";
    //   }
    //   if (!emailValid) {
    //     errorMsg = errorMsg + "Debe tener un formato correcto de email";
    //   }

    //   return errorMsg;
    // },
    errorMessage(vuelidateModelField) {
      var errorMsg = "";

      if (
        vuelidateModelField.$params.required &&
        !vuelidateModelField.required
      ) {
        errorMsg = errorMsg + "Es obligatorio";
      }

      if (vuelidateModelField.$params.email && !vuelidateModelField.email) {
        errorMsg = errorMsg + "Debe tener un formato correcto de email";
      }

      if (vuelidateModelField === this.$v.uiContacto.formulario.telefono) {
        if (!vuelidateModelField.numeric || !vuelidateModelField.minLength) {
          errorMsg = errorMsg + "Debe ser un formato correcto de telefono";
        }
      }

      return errorMsg;
    },
    style4VideoPreview(videoId) {
      return ` -webkit-order: 0; -ms-flex-order: 0; order: 0; -webkit-flex: 0 1 120px; -ms-flex: 0 1 120px; flex: 0 1 120px; -webkit-align-self: auto; -ms-flex-item-align: auto;   align-self: auto; background-image: url("https://i.ytimg.com/vi/${videoId}/mqdefault.jpg");`;
    }
  }
};
</script>

<style lang="scss">
@import "@/components/vue-material-app/default-variables.scss";
@import "@material/layout-grid/mdc-layout-grid.scss";

.mdc-layout-grid.app-layout-grid--detail-container {
  padding: 0 0 0 0;
  margin: 0 0 0 0;
}

.mdc-layout-grid.app-layout-grid--detail-container__data {
  padding: 0 0 0 0;
  margin: 0 0 0 0;
}

.app-layout-grid-cell--detail__tipoBien {
  color: #455a64;
  font-size: 13px;
}

.app-layout-grid-cell--detail__promocion {
  color: #263238;
  font-size: 1.5em;
  font-weight: bold;
}

.app-layout-grid-cell--detail__municipio {
  color: #90a4ae;
  font-size: 15px;
}

.app-layout-grid-cell--campo-titulo {
  font-weight: bold;
  color: #263238;
}

.app-layout-grid-cell--campo-valor {
  color: #455a64;
  white-space: pre-wrap; // Para que no simplique los espacios del codigo
}

.app-layout-grid-cell--observaciones {
  padding-top: 2em;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 2.5em;
  border-top: solid 1px #e0e1e2;
  color: #455a64;

  a {
    color: $mdc-theme-primary;
  }
}

.app-layout-grid-cell--detail__mapa {
  margin-top: 5em;
}

.detail__form-contacto__estado {
  font-weight: bold;
  font-size: 1em;
  color: #263238;
}

.detail__form-contacto__precio {
  line-height: 1.1em;
  font-family: "Roboto Black", "Roboto";
  font-weight: bold;
  font-size: 1.6em;
  text-align: center;
  color: #263238;
}

.app-layout-grid--detail-container__contacto {
  .mdc-button {
    width: 100%;
    height: 51px;
    // height: 56px;
    // font-size: 1em;
  }

  .mdc-text-field:not(.mdc-text-field--textarea) {
    width: 100%;
    height: 46px;

    input.mdc-text-field__input {
      font-size: 0.8125em;
      height: 46px;
    }

    .mdc-floating-label {
      font-size: 0.8125em;
    }

    .mdc-notched-outline {
      height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }

  .mdc-text-field.mdc-text-field--textarea {
    width: 100%;

    textarea.mdc-text-field__input {
      font-size: 0.8125em;
      // height: 46px;
    }

    .mdc-floating-label {
      font-size: 0.8125em;
    }

    .mdc-notched-outline {
      // height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }

  .mdc-select {
    width: 100%;

    select.mdc-select__native-control {
      font-size: 0.8125em;
      height: 46px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .mdc-select__dropdown-icon {
      top: 13px;
    }
    .mdc-floating-label {
      top: 18px;
      font-size: 0.8125em;
    }

    .mdc-notched-outline {
      height: 46px;
    }

    // font-size: 0.9em;
  }
}

.app-layout-grid-cell--detail__form-contacto__estado {
  line-height: 51px;
  text-align: center;
  i {
    margin-right: 4px;
    position: relative;
    bottom: 2px;
    vertical-align: middle;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-layout-grid-cell--detail__form-contacto__estoyinteresado {
    // Para centrar verticalmente el botón
    // https://css-tricks.com/centering-css-complete-guide/
    position: relative;

    button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.app-layout-grid-cell--detail__form-contacto__respuesta__text {
  min-height: 160px;
  text-align: center;
  color: #455a64;

  > div {
    min-height: 160px;
    line-height: 160px;
  }

  p {
    line-height: normal;
  }
}

.app-link--open-in-new {
  color: #1976d2;
  text-decoration: none;
  line-height: 2em;
}

@media (max-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-link--open-in-new {
    display: block;
  }
}

.app-link--open-in-new::after {
  padding-left: 0.2em;
  font-family: "Material Icons";
  content: "open_in_new";
  -webkit-font-feature-settings: "liga" 1;
  -moz-font-feature-settings: "liga" 1;
  font-feature-settings: "liga" 1;
}

.app-link--document {
  display: block;
  position: relative;
  color: #1976d2;
  text-decoration: none;
  line-height: 3em;
  margin-bottom: 1em;
}

.app-link--document::before {
  position: relative;
  top: 0.2em;
  left: -0.1em;
  font-size: 1.5em;
  padding-right: 0.2em;
  font-family: "Material Icons";
  content: "description";
  -webkit-font-feature-settings: "liga" 1;
  -moz-font-feature-settings: "liga" 1;
  font-feature-settings: "liga" 1;
}

.video-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.video-container__language {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 0 1 auto;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;

  .mdc-button {
    display: block !important;

    img {
      width: 24px;
      height: 24px;
      // margin-bottom: 1em;
      // margin-right: 1em;
    }
  }

  .mdc-button--selected {
    img {
      width: 32px;
      height: 32px;
      // margin-bottom: 1em;
      // margin-right: 1em;
    }
  }
}

.video-container__video {
  width: 90%;
  height: auto;
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .video-container__video {
    width: 520px;
    height: 320px;
  }
}

@media (min-device-width: map-get($mdc-layout-grid-breakpoints, "desktop")) {
  .app-text-observaciones {
    margin-bottom: 2em;
  }
}

// .mdc_card.ap-mdc-card--list-item-inmueble {
//   padding: 24px;
// }

// .item-inmueble__tipo-bien {
//   display: inline-block;
//   font-size: 13px;
//   font-weight: 500;
//   color: #455a64;
//   padding: 8px;
// }

// .item-inmueble__referencia {
//   display: inline-block;
//   position: absolute;
//   right: 3px; // Para situarla a la esquina
//   font-size: 15px;
//   font-weight: 500;
//   color: #263238;
//   padding: 8px;
// }

// .item-inmueble__promocion {
//   font-size: 16px;
//   font-weight: bold;
//   color: #263238;
//   padding: 8px;
// }

// .item-inmueble__detalle {
//   font-size: 16px;
//   color: #263238;
//   padding: 8px;
// }

// .app-inmueble-list-item__dialog {
//   .mdc-dialog__surface {
//     max-width: 900px !important;
//   }
// }
</style>
